const initState = {
  post: [],
  convertSignal: false,
  trainingStatus: false,
  classNArr: [],
  globalCam: false,
  startStop: false,
  gClassID: 0,
  gPredsArr: [],
  epochs: 15,
  batchSize: 16,
  learningRate: 0.001 
  
};
const rootReducer = (state = initState, action) => {
  switch (action.type) {
    //INITIATES LEARNING PROCESS IN LEARNING>.JS
    case "UPDATE_SIGNAL":
      return {
        ...state,
        convertSignal: action.signal,
        epochs: action.epochs,
        batchSize: action.batchSize,
        learningRate: action.learningRate
      };
    //TO PREVENT FURTHER ADDITION IMAGE TO GET TRAININED
    case "STOP_TRAINING":
      return {
        ...state,
        convertSignal: action.sSignal
      };
    case "TRAINING_START_STOP":
      return {
        ...state,
        startStop: action.startStopSignal
      };
    //SHOW IF TRAINING IS COMPLETED
    case "TRAINING_STATUS":
      return {
        ...state,
        trainingStatus: action.tStatus
      };
    //STORES CLASS NAME ARRAY
    case "CLASS_ARR":
      return {
        ...state,
        classNArr: action.cArr
      };
    //STATUS OF GLOBAL CAM
    case "GLOBAL_CAM":
      return {
        ...state,
        globalCam: action.gCam,
        gclassID: action.classID
      };
    //STORES PREDICTION ARRAY
    case "PREDICTION %": 
      return {
        ...state,
        gPredsArr: action.preds
      }
    default:
      return state;
  }
};

export default rootReducer;
